import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated:false,
    userType:''
  },
  mutations: {
    SET_USER_TYPE: (state, newValue) => {
      state.userType = newValue
    },
  },
  actions: { setUserType: (state, newValue) => {
    
    state.commit('SET_USER_TYPE', newValue)
       
  },

  },
  getters: {
  
  },
  computed: {
    
  }
})
